import { render, staticRenderFns } from "./fangjiManage.vue?vue&type=template&id=d87f26c0&scoped=true&"
import script from "./fangjiManage.vue?vue&type=script&lang=js&"
export * from "./fangjiManage.vue?vue&type=script&lang=js&"
import style0 from "./fangjiManage.vue?vue&type=style&index=0&id=d87f26c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87f26c0",
  null
  
)

export default component.exports